import React, { useState, useEffect } from "react";
import Link from "next/link";
import {
	AppBar,
	Toolbar,
	IconButton,
	Typography,
	Container,
	List,
	ListItem,
	ListItemAvatar,
	ListItemText,
	Avatar,
	Box,
	CircularProgress,
} from "@mui/material";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { fetchWrapper } from "@/helpers/fetch-wrapper";
import { useChatSocket } from "@/contexts/ChatSocketContext";

export default function Notificari() {
	const [notifications, setNotifications] = useState([]);
	const [loading, setLoading] = useState(true);
	const chatSocket = useChatSocket();

	useEffect(() => {
		const loadNotifications = async () => {
			try {
				const response = await fetchWrapper.get("/api/users/notifications");
				setNotifications(response || []);
			} catch (error) {
				console.error("Eroare la încărcarea notificărilor:", error);
			} finally {
				setLoading(false);
			}
		};

		loadNotifications();
		chatSocket?.markNotificationsRead();
	}, []);

	return (
		<Box sx={{ flexGrow: 1 }}>
			<AppBar position='static' sx={{ backgroundColor: "#F0A500", borderRadius: "16px" }}>
				<Toolbar>
					<Typography variant='h6' sx={{ flexGrow: 1 }}>
						Notificări
					</Typography>
					<IconButton edge='end' color='inherit' aria-label='notificări'>
						<NotificationsIcon />
					</IconButton>
				</Toolbar>
			</AppBar>

			<Container disableGutters maxWidth={false}>
				{loading ? (
					<Box display='flex' justifyContent='center' mt={5}>
						<CircularProgress />
					</Box>
				) : notifications.length === 0 ? (
					<Typography align='center' color='textSecondary' mt={5}>
						Nu aveți notificări noi.
					</Typography>
				) : (
					<List disablePadding>
						{notifications.map((notif, index) => (
							<Link
								href={notif.redirectURL || "#"}
								passHref
								key={index}
								style={{ textDecoration: "none", color: 'black' }}>
								<Box
									component='a'
									sx={{
										display: "flex",
										alignItems: "center",
										textDecoration: "none",
										px: 2,
										py: 1.5,
										mt: 1,
										borderRadius: "16px",
										backdropFilter: "blur(8px)",
										backgroundColor: "rgba(255, 255, 255, 0.2)",
										boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)",
										border: "1px solid rgba(255, 255, 255, 0.3)",
										transition: "background-color 0.3s ease, transform 0.2s ease",
										"&:hover": {
											backgroundColor: "rgba(240, 165, 0, 0.2)",
											transform: "scale(1.02)",
										},
									}}>
									<ListItemAvatar>
										<Avatar sx={{ bgcolor: "#F0A500" }}>
											<NotificationsIcon />
										</Avatar>
									</ListItemAvatar>
									<ListItemText
										primary={
											<Typography sx={{ fontSize: "18px", fontWeight: 500 }}>
												{notif.text || "Notificare"}
											</Typography>
										}
										secondary={
											<Typography
												variant='body2'
												color='text.secondary'
												sx={{ fontSize: "14px", mt: 0.5 }}>
												{new Date(notif.createdAt).toLocaleString()}
											</Typography>
										}
									/>
								</Box>
							</Link>
						))}
					</List>
				)}
			</Container>
		</Box>
	);
}
